
// Polyfill per IE11
//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill

(function(){
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent (event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent( 'CustomEvent');
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


$(document).ready(function(){


    // Anchor scroll with fixed header
    $('body').on('click','a[href^="#"]',function(event){
        event.preventDefault();
        var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;

        var customoffset = 120 // to balance fixed header height
        $('html, body').animate({
            scrollTop:target_offset - customoffset
        }, 500);
    });



    if (window.matchMedia("(max-width: 991px)").matches) {  

        var headerHeight = $('.logoNav').outerHeight();
        var searchFormHeight = parseInt("90px", 10);
        var searchResultPos = headerHeight + searchFormHeight;

        $('div.is-ajax-search-result').css({
            'top': searchResultPos,
            'height' : 'calc(100% - ' + searchResultPos+ 'px)'
        });

        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();

            $(this).toggleClass('is-open');
            $('body').toggleClass('nav-expanded');

            if($('.mobileSearch').hasClass('is-open')){
                $('.mobileSearch').toggleClass('is-open');
                $('body').toggleClass('search-expanded');
            };


        })

        //Sottomenu
        $('.has-submenu>a').on('click',function(event){
            event.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $(this).toggleClass('is-selected');
        });

        // Ricerca
        $('.js-toggleSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('search-expanded').bind('touchmove', function(e){e.preventDefault()});
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                //$(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
                $('body').toggleClass('nav-expanded');
            };

            $('.mobileSearch').css({
                'top': headerHeight,
                'height' : 'calc(100% - ' + headerHeight+ 'px)'
            });

            $('div.is-ajax-search-result').css({
                'top' : searchResultPos,
                'height' : 'calc(100% - ' + searchResultPos+ 'px)'
            });

            $('.is-ajax-search-items').css({
                'height' : 'calc(100% - 50px)',
                'max-height' : 'calc(100% - 50px)'
            });


            if($('.announcement').hasClass('is-hidden')){
                $('.mobileSearch').css({
                    'top' : headerHeight,
                    'height' : 'calc(100% - ' + headerHeight+ 'px)'
                });
                $('div.is-ajax-search-result').css({
                    'top' : searchResultPos,
                    'height' : 'calc(100% - ' + searchResultPos+ 'px)'
                });

            };
        })


        $('.js-closeSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('search-expanded').unbind('touchmove');
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                //$(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
                $('body').toggleClass('nav-expanded');
            };
        })


        $('.js-openFilters').on('click',function(e){
            e.preventDefault();
            $('.filters').slideToggle();
            $('.openToggle').toggleClass('is-open');
        })





        /*     $('.btn-search').on('click',function(e){
            e.preventDefault();
                 $('.searchFormWrap', '.searchForm').show();
        })*/
    }


    // Sottomenu desktop
    if (window.matchMedia("(min-width: 992px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();

            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open');
            }
            
            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }

             if($(this).attr('aria-expanded') == 'true'){    
                $(this).attr('aria-expanded','false').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
            }
    
            else if($(this).attr('aria-expanded') == 'false'){
                $(this).attr('aria-expanded','true').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
            }
        });
        

        // Lingue
        $('.js-dropdown').children('a').on('click', function(event){
        //$('.js-dropdown').children('span').on('click', function(event){
            event.preventDefault();
            $(this).next('ul').toggle();
        });
        
    
  
      $(document).click(function (e) {
        //check if the clicked area is dropDown or not
          if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
          
          if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
                $('.js-dropdown > ul').hide();
            }
           
        })
    }


    // Ricerca + suggerimenti

    /*
    $("input[type='search']").on('focus', function(){
        $(this).removeAttr('placeholder');
    });

    $(".is-ajax-search input[type='search']").on('focusout', function(){
        $("div.is-ajax-search-result").hide();

    });

    $(".is-ajax-search input[type='search']").on('keyup', function(){
        $(".is-loader-image").show();

        var selected = $(this);

        if(selected.val().length >= 1){
            setTimeout(function() { 
                selected.next(".is-loader-image").hide();
                $("div.is-ajax-search-result").show();
            }
                       , 700);
        }

        else{
            selected.next(".is-loader-image").hide();
            setTimeout(function() { 
                $("div.is-ajax-search-result").hide();    
            }
                       , 700);
        }
    });
    */

    // Apertura form info

    $(".js-open-form").on('click', function(e){
        e.preventDefault();
        $(".infoForm").css('margin-top','-40px').slideDown();
        $(".infoForm").parents('.contentWrapNarrow').find('.js-open-form').css('opacity','0');
        //$("#mainText .js-open-form").css('opacity','0');    
    });
    /*
    $(".js-open-form").on('click', function(e){
        e.preventDefault();
        $(".infoForm").slideDown();
    });
    */



    // Slick + slick Lightbox

    /* $('.carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3.25,
        slidesToScroll: 3,
        dots:false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.25,
                    slidesToScroll: 2,
                    infinite: false,
                    dots:false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                    infinite: false,
                    dots:false,
                }
            }
        ]
    });

    $('.carousel').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });*/


    $('.carouselMasthead').slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        lazyLoad: 'ondemand'
    });
    
    $('.carouselProduct').slick({
        dots:false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand'
    });

    $('.carouselProduct').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });


    $('.carouselMasthead').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });



    //Accordion

    //$('.accordion .accordion__item.accordion__content').show();

    var item = document.querySelectorAll('.accordion__item');
    for(var i = 0; i < item.length; i++) {
        item[i].classList.add('js-item');
        //console.log(title[i].classList);
    }

    var title = document.querySelectorAll('.accordion__header');
    for(var i = 0; i < title.length; i++) {
        title[i].classList.add('js-header');
        //console.log(title[i].classList);
    }

    var copy = document.querySelectorAll('.accordion__content');
    for(var i = 0; i < copy.length; i++) {
        copy[i].classList.add('js-content');
        //console.log(copy[i].classList);
    }

    /*$('.accordion .js-content').show();    
    $('.accordion__item .js-header').attr('aria-expanded','true');*/
    /*$('.accordion .js-content').slideUp();    
    $('.accordion__item .js-header').attr('aria-expanded','false');*/
    $('.accordion .js-content').hide();    
    $('.accordion__item .js-header').attr('aria-expanded','false');

    // Primo elemento aperto
    //$('.accordion .accordion__item:first-child .js-header').toggleClass('active');
    //$('.accordion .accordion__item:first-child .js-content').slideDown();
    //$('.accordion__item:first-child .js-header').attr('aria-expanded','true');



    //var $title = $('.accordion .js-header');

    $('.accordion .js-header').click(function () {
        $(this).next(copy).slideToggle();
        /*$(this).parent().siblings().children().next().slideUp();
        $(this).parent().siblings().children().removeClass('active');*/
        $(this).toggleClass('active');



        // toggle attributi
        if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }

        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }

        return false;

    });

    var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header



    $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina


        var keyCode = e.keyCode || e.which;


        if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar


            $(this).children(title).next(copy).slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');

            $(this).siblings().children().removeClass('active');


            if($(this).children(title).attr('aria-expanded') == 'true'){
                $(this).children(title).attr('aria-expanded','false');
            }

            else if($(this).children(title).attr('aria-expanded') == 'false'){
                $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
            }

            return false;
        }

    });

    if (window.matchMedia("(min-width: 992px)").matches){
        /*$('.accordion .accordion__item.accordion__content').show();*/
        $('.accordion .js-content').show();    
        $('.accordion__item .js-header').attr('aria-expanded','true');
    }

    // TABS-ACCORDION

    var $titleTabs = $('.tabs-accordion .js-header');


    if (window.matchMedia("(max-width: 767px)").matches){


        $('.tabs-accordion .js-content').hide();
        $('.tabs-accordion .accordion__item .js-header').attr('aria-expanded','false');


        $('.tabs-accordion .accordion__item:first-child .js-header').toggleClass('active');
        //$('.tabs-accordion .accordion__item:first-child .js-content').show();
        $('.accordion__item:first-child .js-header').attr('aria-expanded','true');


        $titleTabs.click(function () {
            $(this).next().slideToggle();
            $(this).toggleClass('active');
            $(this).parent().siblings().children().next().slideUp();
            $(this).parent().siblings().children().removeClass('active');
            return false;
        });


        $titleTabs.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina
            var keyCode = e.keyCode || e.which;

            if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar
                $(this).next(copy).slideToggle();
                $(this).toggleClass('active');
                $(this).parent().siblings().children().next().slideUp();
                $(this).parent().siblings().children().removeClass('active');


                return false;
            }
        });
    }


    else if (window.matchMedia("(min-width: 768px)").matches){

        // Hide all but first tab content on larger viewports
        $('.tabs-accordion .js-content:not(:first)').css('display', 'none');

        // Activate first tab
        $(".tabs-accordion .accordion__header[aria-controls='panel0']").addClass('active');


        //var contentHeight = $('.accordion__item:first-child .accordion__header.active').next('.js-content').children('.blockTxtImg').outerHeight();  

        //var contentHeight = $('.accordion__content').outerHeight();                


        //$('.tabs-accordion').height(contentHeight); //  altezza header + padding testo

        $titleTabs.click(function () {                                      
            $(this).next().css('display', 'flex');
            $(this).parent().siblings().children().next().css('display', 'none');
            $(this).addClass('active');
            $(this).parent().siblings().children().removeClass('active');

            //var newContentHeight = $(this).next('.js-content').outerHeight();          
            //$('.tabs-accordion').height(newContentHeight ); //  altezza header

            return false;
        });


        $titleTabs.focus(function(e){

            $(this).next().css('display', 'flex');
            $(this).parent().siblings().children().next().css('display', 'none');
            $(this).addClass('active');
            $(this).parent().siblings().children().removeClass('active');

            /* var newContentHeight = $('.js-header.active').next('.js-content').children('.blockTxtImg').outerHeight();          
        $('.tabs-accordion').height(newContentHeight + 64);*/

            $(this).parent().attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        });
    } 

    // FAQ
    $('.faq h3').on('click',function(event){
        event.preventDefault();
        $(this).next('div').slideToggle('200');
        $(this).toggleClass('is-selected');

        if($(this).children('button').attr('aria-expanded') == 'true'){
          $(this).children('button').attr('aria-expanded','false');
      }

      else if($(this).children('button').attr('aria-expanded') == 'false'){
          $(this).children('button').attr('aria-expanded','true').siblings().attr('aria-expanded','false');
      }
    });

    $('a[href^="http"]').each(function() {
        // Apro in blank i link esterni e a PDF
        var a = new RegExp('/' + window.location.host + '/');
        if (! a.test(this.href) || /\.pdf/.test(this.href)) {
            $(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    })

});


// Intersection observer per "accendere" voci menu contestuale

let options = {
    //root: document.querySelector('#productExtras'),
    rootMargin: '0px 0px -50% 0px',
    threshold: 0
}


let callback = (entries, observer) => {
    entries.forEach(entry => {
        //console.log(entry);
        if(entry.isIntersecting){
            //console.log('metti il pallino su '+entry.target.id);
            addClass(entry.target);
        }
        else{
            //console.log('togli il pallino su '+entry.target.id);
            removeClass(entry.target);
        }
    });

    $('[id^="anchor-"]').each(function(e) {
        var thisID = $(this).attr('id');
        if ($(this).hasClass('entering')){
            $('.contentWrapAside__menu a').removeClass('active');
            $('a[href$="#' + thisID + '"]').addClass('active');
        }
    });
    
    /* Esempio statico:
    if($("#anchor1").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor1']").addClass("active");
    }
    if($("#anchor2").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor2']").addClass("active");
    }
    */
};



function addClass(entry) {
    if (!entry.classList.contains('entering')) {
        entry.classList.add('entering');
    }
}

function removeClass(entry) {
    if (entry.classList.contains('entering')) {
        entry.classList.remove('entering');
    }
}


let observer = new IntersectionObserver(callback, options);
const entries = [].slice.call(document.querySelectorAll('.toObserve'));
entries.forEach(entry => observer.observe(entry)); 

/*
// Store the window width
var windowWidth = $(window).width();

//Resize Event
$(window).resize(function(){
    // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
    if ($(window).width() != windowWidth) {

        // Update the window width for next time
        windowWidth = $(window).width();

        setTimeout(function(){
            window.location.reload();
        });

    }
});
*/

// Newsletter popup
$(document).ready(function(){

    var $source = $('.exitIntent-popup');

    if ($source.length > 0) {

        // Inizializza il plugin
        $source.ysExit({
            debug: false,
            cookieName: 'subscribe-popup',
            cookieValidity: 3,
            delay: 2
        });

        // SOLUZIONE ACCESSIBILE:
        // Il plugin ha clonato il contenuto in #ys-container.
        // Rimuoviamo l'originale dal DOM così non esistono più doppioni.
        $source.not('#ys-container .exitIntent-popup').remove();

    }
});
$(document).on('keydown', function(e) {
    if (e.key === "Escape") { // Se l'utente preme ESC
        if ($('#ys-container').is(':visible')) {
            // Richiama la funzione di chiusura della libreria
            // Solitamente basta nascondere il contenitore e il layer
            $('#ys-container, #ys-layer').fadeOut();
        }
    }
});
